import RecorderV1 from './RecorderV1'

export default RecorderV1